import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { SharedModule } from '../../shared.module';
import { UserService } from '../../../core/services/user.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../authentication/services/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule, SharedModule, RouterLink]
})
export class FooterComponent implements OnInit, OnDestroy {
  private userJourney: string | null = null;
  sub = new Subscription();

  get isParentUser(): boolean {
    return this.userJourney?.toLowerCase() === 'parent';
  }

  constructor(
    private userService: UserService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.sub.add(
        this.userService
          .getUserJourney()
          .subscribe((journey) => (this.userJourney = journey))
      );

      this.sub.add(
        this.userService.journey$.subscribe(
          (journey) => (this.userJourney = journey)
        )
      );
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
